import script from "./ProductView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductView.vue?vue&type=script&lang=ts&setup=true"

import "./ProductView.vue?vue&type=style&index=0&id=0529f0d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0529f0d0"]])

export default __exports__